import React from 'react';
import { FlexFitCenter, FormContainer, MainContent, PageTitle } from '@/app/[locale]/(welcome)/_components';
import { useTranslations } from 'next-intl';
import { FlexColMD } from '@/components/Flex';
import { Field, Form } from 'formik';
import Button from '@/components/core/Button';
import { PasswordInput } from '@/app/[locale]/(welcome)/auth/(with_banner)/signup/PasswordInput';
import { PasswordCriteria } from '@/app/[locale]/(welcome)/auth/(with_banner)/signup/PasswordCriteria';
import { Loader } from '@/components/core/Loader';
import styled from 'styled-components';
import { device } from '@/components/Media';

const CenteredFlexColMD = styled(FlexColMD)`
  align-items: center;
  
  @media ${device.laptopS} {
    width: 100%;
    gap:  ${({ theme }) => theme.spacing['2xs']};
  }
`;

const CompleteButton = styled(Button)`
  @media ${device.laptopS} {
    width: 100%;
    justify-content: center;
  }
`;

export function SetPasswordForm({
    values,
    setFieldValue,
    loading
}) {
    const t = useTranslations();

    return (
        <MainContent>
            <PageTitle>
                {t.rich('auth.setPasswordTitle', { br: () => <br /> })}
            </PageTitle>

            {loading ? (
                <FlexFitCenter>
                    <Loader size='lg' variant='grey' />
                </FlexFitCenter>
            ) : (
                <Form method='post'>
                    <FormContainer>
                        <CenteredFlexColMD>
                            <Field
                              component={PasswordInput}
                              name='password'
                              showPassword={values.showPassword}
                              setShowPassword={val => setFieldValue('showPassword', val)}
                              placeholder={t('auth.enterNewPass')}
                            />

                            <Field
                              component={PasswordInput}
                              name='confirmPassword'
                              showPassword={values.showConfirmPassword}
                              setShowPassword={val => setFieldValue('showConfirmPassword', val)}
                              placeholder={t('auth.confirmNewPass')}
                            />

                            <PasswordCriteria password={values.password} />

                            <CompleteButton type='submit' variant='filled' size='lg' innerText={t('auth.complete')} />
                        </CenteredFlexColMD>
                    </FormContainer>
                </Form>
            )}
        </MainContent>
    );
}
